import { UserIcon } from "@phosphor-icons/react";
import type React from "react";

interface ArticleAuthorProps {
  authors?: string[] | null;
}

const ArticleAuthor: React.FC<ArticleAuthorProps> = ({ authors }) => {
  const authorNames = authors?.filter(Boolean).join(", ");

  if (!authorNames) return null;

  return (
    <div className="flex items-center gap-1.5 text-xs text-gray-900">
      <UserIcon size={16} />
      <span>{authorNames}</span>
    </div>
  );
};

export default ArticleAuthor;
